export const ttlOptions = [
  { value: 15, label: 'quarter of an hour' },
  { value: 30, label: 'half an hour' },
  { value: 60, label: 'an hour' },
  { value: 12 * 60, label: 'half a day' },
  { value: 24 * 60, label: 'a day' },
  { value: 7 * 24 * 60, label: 'a week' },
  { value: 14 * 24 * 60, label: 'two weeks' },
  { value: 30 * 24 * 60, label: 'a month' },
  { value: 91 * 24 * 60, label: 'quarter of the year' },
  { value: 182 * 24 * 60, label: 'half a year' },
  { value: 365 * 24 * 60, label: 'year' },
];
